module.exports = "<p>\n  program-shift-student works!\n</p>\n"